// Generated by Melange

import * as $$BigInt from "./BigInt.mjs";
import * as Caml_option from "melange.js/caml_option.mjs";
import * as Curry from "melange.js/curry.mjs";
import * as Interop from "./Interop.mjs";
import * as Warblre_js__BigInt from "warblre-engines.js/BigInt.mjs";

function xorb(b1, b2) {
  if (b1) {
    if (b2) {
      return false;
    } else {
      return true;
    }
  } else {
    return b2;
  }
}

function negb(param) {
  if (param) {
    return false;
  } else {
    return true;
  }
}

function option_map(f, a) {
  if (a !== undefined) {
    return Caml_option.some(Curry._1(f, Caml_option.valFromOption(a)));
  }
  
}

function fst(param) {
  return param[0];
}

function snd(param) {
  return param[1];
}

function length(param) {
  if (param) {
    return Warblre_js__BigInt.Nat.succ(length(param.tl));
  } else {
    return $$BigInt.zero;
  }
}

function app(l, m) {
  if (l) {
    return {
      hd: l.hd,
      tl: app(l.tl, m)
    };
  } else {
    return m;
  }
}

function compareSpec2Type(param) {
  switch (param) {
    case /* Eq */ 0 :
      return /* CompEqT */ 0;
    case /* Lt */ 1 :
      return /* CompLtT */ 1;
    case /* Gt */ 2 :
      return /* CompGtT */ 2;
  }
}

function compSpec2Type(param, param$1) {
  return compareSpec2Type;
}

const sub = Warblre_js__BigInt.Nat.min;

function MakeOrderTac(O, P) {
  return {};
}

const sub$1 = Warblre_js__BigInt.Nat.min;

function divmod(x, y, q, u) {
  if (Curry._1($$BigInt.equal(x), $$BigInt.zero)) {
    return [
      q,
      u
    ];
  } else {
    let x$p = Warblre_js__BigInt.Nat.pred(x);
    if (Curry._1($$BigInt.equal(u), $$BigInt.zero)) {
      return divmod(x$p, y, Warblre_js__BigInt.Nat.succ(q), y);
    } else {
      let u$p = Warblre_js__BigInt.Nat.pred(u);
      return divmod(x$p, y, q, u$p);
    }
  }
}

const Nat = {
  sub: sub$1,
  leb: $$BigInt.le,
  divmod: divmod
};

function map(f, param) {
  if (param) {
    return {
      hd: Curry._1(f, param.hd),
      tl: map(f, param.tl)
    };
  } else {
    return /* [] */ 0;
  }
}

function firstn(n, l) {
  if (Curry._1($$BigInt.equal(n), $$BigInt.zero)) {
    return /* [] */ 0;
  } else {
    let n0 = Warblre_js__BigInt.Nat.pred(n);
    if (l) {
      return {
        hd: l.hd,
        tl: firstn(n0, l.tl)
      };
    } else {
      return /* [] */ 0;
    }
  }
}

function skipn(n, l) {
  if (Curry._1($$BigInt.equal(n), $$BigInt.zero)) {
    return l;
  } else {
    let n0 = Warblre_js__BigInt.Nat.pred(n);
    if (l) {
      return skipn(n0, l.tl);
    } else {
      return /* [] */ 0;
    }
  }
}

function in_dec(h, a, _param) {
  while (true) {
    const param = _param;
    if (!param) {
      return false;
    }
    const s = Curry._2(h, param.hd, a);
    if (s) {
      return true;
    }
    _param = param.tl;
    continue;
  };
}

function rev(param) {
  if (param) {
    return app(rev(param.tl), {
      hd: param.hd,
      tl: /* [] */ 0
    });
  } else {
    return /* [] */ 0;
  }
}

function fold_left(f, _l, _a0) {
  while (true) {
    const a0 = _a0;
    const l = _l;
    if (!l) {
      return a0;
    }
    _a0 = Curry._2(f, a0, l.hd);
    _l = l.tl;
    continue;
  };
}

function fold_right(f, a0, param) {
  if (param) {
    return Curry._2(f, param.hd, fold_right(f, a0, param.tl));
  } else {
    return a0;
  }
}

const Pos = {
  iter_op: Interop.erased
};

function eq_dec(type0) {
  return type0;
}

function eqb(h, l, r) {
  if (Curry._2(h, l, r)) {
    return true;
  } else {
    return false;
  }
}

const EqDec = {
  eq_dec: eq_dec,
  eqb: eqb
};

function bind(r, f) {
  return Curry._1(f, r);
}

const Result = {
  bind: bind
};

function inb(eqDec0, x, l) {
  if (in_dec(eqDec0, x, l)) {
    return true;
  } else {
    return false;
  }
}

const List = {
  inb: inb
};

function positive_to_nat(x) {
  return x;
}

const NonNegInt = {
  modulo: $$BigInt.rem
};

const NoI = {};

function multiline(t0) {
  return t0.multiline;
}

function dotAll(t0) {
  return t0.dotAll;
}

const RegExpRecord = {
  multiline: multiline,
  dotAll: dotAll
};

function eq_dec$1(class0) {
  return class0.eq_dec;
}

function from_numeric_value(class0) {
  return class0.from_numeric_value;
}

function numeric_value(class0) {
  return class0.numeric_value;
}

function canonicalize(class0) {
  return class0.canonicalize;
}

function all(class0) {
  return class0.all;
}

function line_terminators(class0) {
  return class0.line_terminators;
}

function digits(class0) {
  return class0.digits;
}

function white_spaces(class0) {
  return class0.white_spaces;
}

function ascii_word_characters(class0) {
  return class0.ascii_word_characters;
}

const Character = {
  eq_dec: eq_dec$1,
  from_numeric_value: from_numeric_value,
  numeric_value: numeric_value,
  canonicalize: canonicalize,
  all: all,
  line_terminators: line_terminators,
  digits: digits,
  white_spaces: white_spaces,
  ascii_word_characters: ascii_word_characters
};

function from_list(param, class0) {
  return class0.from_list;
}

function union(param, class0) {
  return class0.union;
}

function remove_all(param, class0) {
  return class0.remove_all;
}

function contains(param, class0) {
  return class0.contains;
}

function range(param, class0) {
  return class0.range;
}

function filter(param, class0) {
  return class0.filter;
}

function exist_canonicalized(param, class0) {
  return class0.exist_canonicalized;
}

const CharSet = {
  from_list: from_list,
  union: union,
  remove_all: remove_all,
  contains: contains,
  range: range,
  filter: filter,
  exist_canonicalized: exist_canonicalized
};

const $$String = {};

function code_points_for(class0) {
  return class0.code_points_for;
}

const Property = {
  code_points_for: code_points_for
};

function character_class(class0) {
  return class0.character_class;
}

function set_class(class0) {
  return class0.set_class;
}

function unicode_property_class(class0) {
  return class0.unicode_property_class;
}

const Parameters = {
  character_class: character_class,
  set_class: set_class,
  unicode_property_class: unicode_property_class
};

function coq_NULL(specParameters) {
  return Curry._1(specParameters.character_class.from_numeric_value, $$BigInt.zero);
}

function coq_BACKSPACE(specParameters) {
  return Curry._1(specParameters.character_class.from_numeric_value, Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))));
}

function coq_CHARACTER_TABULATION(specParameters) {
  return Curry._1(specParameters.character_class.from_numeric_value, Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))));
}

function coq_LINE_FEED(specParameters) {
  return Curry._1(specParameters.character_class.from_numeric_value, Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))));
}

function coq_LINE_TABULATION(specParameters) {
  return Curry._1(specParameters.character_class.from_numeric_value, Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))));
}

function coq_FORM_FEED(specParameters) {
  return Curry._1(specParameters.character_class.from_numeric_value, Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))));
}

function coq_CARRIAGE_RETURN(specParameters) {
  return Curry._1(specParameters.character_class.from_numeric_value, Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))));
}

function coq_HYPHEN_MINUS(specParameters) {
  return Curry._1(specParameters.character_class.from_numeric_value, Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))));
}

function all$1(specParameters) {
  return Curry._1(specParameters.set_class.from_list, specParameters.character_class.all);
}

function line_terminators$1(specParameters) {
  return Curry._1(specParameters.set_class.from_list, specParameters.character_class.line_terminators);
}

function digits$1(specParameters) {
  return Curry._1(specParameters.set_class.from_list, specParameters.character_class.digits);
}

function white_spaces$1(specParameters) {
  return Curry._1(specParameters.set_class.from_list, specParameters.character_class.white_spaces);
}

function ascii_word_characters$1(specParameters) {
  return Curry._1(specParameters.set_class.from_list, specParameters.character_class.ascii_word_characters);
}

const Characters = {
  coq_NULL: coq_NULL,
  coq_BACKSPACE: coq_BACKSPACE,
  coq_CHARACTER_TABULATION: coq_CHARACTER_TABULATION,
  coq_LINE_FEED: coq_LINE_FEED,
  coq_LINE_TABULATION: coq_LINE_TABULATION,
  coq_FORM_FEED: coq_FORM_FEED,
  coq_CARRIAGE_RETURN: coq_CARRIAGE_RETURN,
  coq_HYPHEN_MINUS: coq_HYPHEN_MINUS,
  all: all$1,
  line_terminators: line_terminators$1,
  digits: digits$1,
  white_spaces: white_spaces$1,
  ascii_word_characters: ascii_word_characters$1
};

function lindenParameters_of_warblre(p) {
  return {
    char: p.character_class,
    unicodeProp: p.unicode_property_class,
    charset_class: p.set_class
  };
}

function findA(f, _param) {
  while (true) {
    const param = _param;
    if (!param) {
      return;
    }
    const p = param.hd;
    if (Curry._1(f, p[0])) {
      return Caml_option.some(p[1]);
    }
    _param = param.tl;
    continue;
  };
}

function to_integer(param) {
  switch (param) {
    case /* Coq_x0 */ 0 :
      return $$BigInt.zero;
    case /* Coq_x1 */ 1 :
      return Warblre_js__BigInt.Nat.succ($$BigInt.zero);
    case /* Coq_x2 */ 2 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero));
    case /* Coq_x3 */ 3 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)));
    case /* Coq_x4 */ 4 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))));
    case /* Coq_x5 */ 5 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))));
    case /* Coq_x6 */ 6 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))));
    case /* Coq_x7 */ 7 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))));
    case /* Coq_x8 */ 8 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))));
    case /* Coq_x9 */ 9 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))));
    case /* Coq_xA */ 10 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))));
    case /* Coq_xB */ 11 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))));
    case /* Coq_xC */ 12 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))));
    case /* Coq_xD */ 13 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))));
    case /* Coq_xE */ 14 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))));
    case /* Coq_xF */ 15 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))));
  }
}

function to_integer_2(h, l) {
  const r0 = to_integer(h);
  return Curry._1($$BigInt.add(Curry._1($$BigInt.mult(r0), Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))), to_integer(l));
}

function to_integer_4(param) {
  const r0 = to_integer(param._0);
  const r1 = Curry._1($$BigInt.add(Curry._1($$BigInt.mult(r0), Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))), to_integer(param._1));
  const r2 = Curry._1($$BigInt.add(Curry._1($$BigInt.mult(r1), Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))), to_integer(param._2));
  return Curry._1($$BigInt.add(Curry._1($$BigInt.mult(r2), Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))), to_integer(param._3));
}

const HexDigit = {
  to_integer: to_integer,
  to_integer_2: to_integer_2,
  to_integer_4: to_integer_4
};

function numeric_value$1(param) {
  switch (param) {
    case /* Coq_a */ 0 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Coq_b */ 1 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Coq_c */ 2 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Coq_d */ 3 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Coq_e */ 4 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Coq_f */ 5 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Coq_g */ 6 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Coq_h */ 7 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Coq_i */ 8 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Coq_j */ 9 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Coq_k */ 10 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Coq_l */ 11 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Coq_m */ 12 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Coq_n */ 13 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Coq_o */ 14 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Coq_p */ 15 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Coq_q */ 16 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Coq_r */ 17 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Coq_s */ 18 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Coq_t */ 19 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Coq_u */ 20 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Coq_v */ 21 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Coq_w */ 22 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Coq_x */ 23 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Coq_y */ 24 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Coq_z */ 25 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* A */ 26 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* B */ 27 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* C */ 28 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* D */ 29 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* E */ 30 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* F */ 31 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* G */ 32 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* H */ 33 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* I */ 34 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* J */ 35 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* K */ 36 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* L */ 37 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* M */ 38 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* N */ 39 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* O */ 40 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* P */ 41 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Q */ 42 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* R */ 43 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* S */ 44 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* T */ 45 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* U */ 46 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* V */ 47 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* W */ 48 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* X */ 49 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Y */ 50 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    case /* Z */ 51 :
      return Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
  }
}

const AsciiLetter = {
  numeric_value: numeric_value$1
};

function utf16SurrogatePair(lead, trail) {
  const p = Curry._1($$BigInt.shift_left(Curry._1($$BigInt.add($$BigInt.one), Curry._1($$BigInt.shift_left($$BigInt.one), 1))), 1);
  const p$1 = Curry._1($$BigInt.add($$BigInt.one), Curry._1($$BigInt.shift_left(p), 1));
  const p$2 = Curry._1($$BigInt.shift_left(Curry._1($$BigInt.add($$BigInt.one), Curry._1($$BigInt.shift_left($$BigInt.one), 1))), 1);
  const p$3 = Curry._1($$BigInt.add($$BigInt.one), Curry._1($$BigInt.shift_left(p$2), 1));
  const p$4 = Curry._1($$BigInt.add($$BigInt.one), Curry._1($$BigInt.shift_left(p$3), 1));
  return Curry._1($$BigInt.add(Curry._1($$BigInt.add(Curry._1($$BigInt.mult(Curry._1(sub(lead), Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.add($$BigInt.one), Curry._1($$BigInt.shift_left(p$1), 1))), 1)), 1)), 1)), 1)), 1)), 1)), 1)), 1)), 1)), 1)), 1))), Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left($$BigInt.one), 1)), 1)), 1)), 1)), 1)), 1)), 1)), 1)), 1)), 1))), Curry._1(sub(trail), Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.add($$BigInt.one), Curry._1($$BigInt.shift_left(p$4), 1))), 1)), 1)), 1)), 1)), 1)), 1)), 1)), 1)), 1)), 1)))), Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left(Curry._1($$BigInt.shift_left($$BigInt.one), 1)), 1)), 1)), 1)), 1)), 1)), 1)), 1)), 1)), 1)), 1)), 1)), 1)), 1)), 1)), 1));
}

const Unicode = {
  utf16SurrogatePair: utf16SurrogatePair
};

const MatchError = {};

const Patterns = {};

function string_eq_dec(params, _x, _y) {
  while (true) {
    const y = _y;
    const x = _x;
    if (!x) {
      if (y) {
        return false;
      } else {
        return true;
      }
    }
    if (!y) {
      return false;
    }
    if (!Curry._2(params.char.eq_dec, x.hd, y.hd)) {
      return false;
    }
    _y = y.tl;
    _x = x.tl;
    continue;
  };
}

function substring0(params, s, n, m) {
  if (Curry._1($$BigInt.equal(n), $$BigInt.zero)) {
    if (Curry._1($$BigInt.equal(m), $$BigInt.zero)) {
      return /* [] */ 0;
    } else {
      let m$p = Warblre_js__BigInt.Nat.pred(m);
      if (s) {
        return {
          hd: s.hd,
          tl: substring0(params, s.tl, $$BigInt.zero, m$p)
        };
      } else {
        return s;
      }
    }
  } else {
    let n$p = Warblre_js__BigInt.Nat.pred(n);
    if (s) {
      return substring0(params, s.tl, n$p, m);
    } else {
      return s;
    }
  }
}

function advanceStringIndex0(param, param$1, i) {
  return Warblre_js__BigInt.Nat.succ(i);
}

function getStringIndex0(param, param$1, i) {
  return i;
}

function to_char_list0(param, s) {
  return s;
}

function string_String(params) {
  return {
    eqdec: (function (param, param$1) {
      return string_eq_dec(params, param, param$1);
    }),
    length: length,
    substring: (function (param, param$1, param$2) {
      return substring0(params, param, param$1, param$2);
    }),
    advanceStringIndex: (function (param, param$1) {
      return Warblre_js__BigInt.Nat.succ(param$1);
    }),
    getStringIndex: (function (param, param$1) {
      return param$1;
    }),
    to_char_list: (function (param) {
      return param;
    })
  };
}

function lWParameters(params) {
  return {
    character_class: params.char,
    set_class: params.charset_class,
    string_class: string_String(params),
    unicode_property_class: params.unicodeProp
  };
}

function wrap_CharSet(param, s) {
  return Interop.success(s);
}

const Coercions = {
  wrap_CharSet: wrap_CharSet
};

function wordCharacters(specParameters, param, rer) {
  const basicWordChars = ascii_word_characters$1(specParameters);
  let extraWordChars = Interop.success(Curry._2(specParameters.set_class.filter, all$1(specParameters), (function (c) {
    const canonicalized_c = Curry._2(specParameters.character_class.canonicalize, rer, c);
    const param = Curry._2(specParameters.set_class.contains, basicWordChars, c);
    if (param ? false : true) {
      return Curry._2(specParameters.set_class.contains, basicWordChars, canonicalized_c);
    } else {
      return false;
    }
  })));
  return Interop.success(Curry._2(specParameters.set_class.union, basicWordChars, extraWordChars));
}

const Semantics = {
  wordCharacters: wordCharacters
};

function input_eq_dec(params, i1, i2) {
  if (string_eq_dec(params, i1._0, i2._0)) {
    return string_eq_dec(params, i1._1, i2._1);
  } else {
    return false;
  }
}

function idx(param, param$1) {
  return length(param$1._1);
}

function input_str(param, param$1) {
  return app(rev(param$1._1), param$1._0);
}

function substr(params, inp0, startIdx0, endIdx0) {
  return firstn(Curry._1(sub(endIdx0), startIdx0), skipn(startIdx0, input_str(params, inp0)));
}

function init_input(param, str) {
  return {
    TAG: /* Input */ 0,
    _0: str,
    _1: /* [] */ 0
  };
}

function wordCharacters0(params, rer) {
  return wordCharacters(lWParameters(params), /* AssertionFailed */ 1, rer);
}

function word_char(params, rer, c) {
  return Curry._2(params.charset_class.contains, wordCharacters0(params, rer), c);
}

function dot_matches(params, rer, dotAll0, c) {
  if (dotAll0) {
    return Curry._3(lWParameters(params).set_class.exist_canonicalized, rer, all$1(lWParameters(params)), c);
  } else {
    return Curry._3(lWParameters(params).set_class.exist_canonicalized, rer, Curry._2(lWParameters(params).set_class.remove_all, all$1(lWParameters(params)), line_terminators$1(lWParameters(params))), c);
  }
}

function char_match$p(params, rer, ccan, _c$p) {
  while (true) {
    const c$p = _c$p;
    if (/* tag */ typeof c$p === "number" || typeof c$p === "string") {
      switch (c$p) {
        case /* CdEmpty */ 0 :
          return false;
        case /* CdDot */ 1 :
          return dot_matches(params, rer, rer.dotAll, ccan);
        case /* CdAll */ 2 :
          return true;
        case /* CdDigits */ 3 :
          return Curry._3(lWParameters(params).set_class.exist_canonicalized, rer, digits$1(lWParameters(params)), ccan);
        case /* CdNonDigits */ 4 :
          return Curry._3(lWParameters(params).set_class.exist_canonicalized, rer, Curry._2(lWParameters(params).set_class.remove_all, all$1(lWParameters(params)), digits$1(lWParameters(params))), ccan);
        case /* CdWhitespace */ 5 :
          return Curry._3(lWParameters(params).set_class.exist_canonicalized, rer, Curry._2(lWParameters(params).set_class.union, white_spaces$1(lWParameters(params)), line_terminators$1(lWParameters(params))), ccan);
        case /* CdNonWhitespace */ 6 :
          return Curry._3(lWParameters(params).set_class.exist_canonicalized, rer, Curry._2(lWParameters(params).set_class.remove_all, all$1(lWParameters(params)), Curry._2(lWParameters(params).set_class.union, white_spaces$1(lWParameters(params)), line_terminators$1(lWParameters(params)))), ccan);
        case /* CdWordChar */ 7 :
          return Curry._3(params.charset_class.exist_canonicalized, rer, wordCharacters0(params, rer), ccan);
        case /* CdNonWordChar */ 8 :
          return Curry._3(params.charset_class.exist_canonicalized, rer, Curry._2(lWParameters(params).set_class.remove_all, all$1(lWParameters(params)), wordCharacters0(params, rer)), ccan);
      }
    } else {
      switch (c$p.TAG) {
        case /* CdSingle */ 0 :
          return eqb(params.char.eq_dec, ccan, Curry._2(params.char.canonicalize, rer, c$p._0));
        case /* CdUnicodeProp */ 1 :
          return Curry._3(params.charset_class.exist_canonicalized, rer, Curry._1(params.charset_class.from_list, Curry._1(params.unicodeProp.code_points_for, c$p._0)), ccan);
        case /* CdNonUnicodeProp */ 2 :
          return Curry._3(params.charset_class.exist_canonicalized, rer, Curry._2(lWParameters(params).set_class.remove_all, all$1(lWParameters(params)), Curry._1(params.charset_class.from_list, Curry._1(params.unicodeProp.code_points_for, c$p._0))), ccan);
        case /* CdInv */ 3 :
          const param = char_match$p(params, rer, ccan, c$p._0);
          if (param) {
            return false;
          } else {
            return true;
          }
        case /* CdRange */ 4 :
          const i = Curry._1(params.char.numeric_value, c$p._0);
          const j = Curry._1(params.char.numeric_value, c$p._1);
          const charSet = Curry._2(params.charset_class.range, Curry._1(params.char.from_numeric_value, i), Curry._1(params.char.from_numeric_value, j));
          return Curry._3(params.charset_class.exist_canonicalized, rer, charSet, ccan);
        case /* CdUnion */ 5 :
          if (char_match$p(params, rer, ccan, c$p._0)) {
            return true;
          }
          _c$p = c$p._1;
          continue;
      }
    }
  };
}

function char_match(params, rer, c, cd) {
  return char_match$p(params, rer, Curry._2(params.char.canonicalize, rer, c), cd);
}

function read_char(params, rer, cd, i, dir0) {
  const pref = i._1;
  const next = i._0;
  if (dir0 === /* Forward */ 0) {
    if (!next) {
      return;
    }
    const h = next.hd;
    if (char_match(params, rer, h, cd)) {
      return [
        h,
        {
          TAG: /* Input */ 0,
          _0: next.tl,
          _1: {
            hd: h,
            tl: pref
          }
        }
      ];
    } else {
      return;
    }
  }
  if (!pref) {
    return;
  }
  const h$1 = pref.hd;
  if (char_match(params, rer, h$1, cd)) {
    return [
      h$1,
      {
        TAG: /* Input */ 0,
        _0: {
          hd: h$1,
          tl: next
        },
        _1: pref.tl
      }
    ];
  }
  
}

function advance_input(param, i, dir0) {
  const pref = i._1;
  const next = i._0;
  if (dir0 === /* Forward */ 0) {
    if (next) {
      return {
        TAG: /* Input */ 0,
        _0: next.tl,
        _1: {
          hd: next.hd,
          tl: pref
        }
      };
    } else {
      return;
    }
  } else if (pref) {
    return {
      TAG: /* Input */ 0,
      _0: {
        hd: pref.hd,
        tl: next
      },
      _1: pref.tl
    };
  } else {
    return;
  }
}

function advance_input$p(params, i, dir0) {
  const nextinp = advance_input(params, i, dir0);
  if (nextinp !== undefined) {
    return nextinp;
  } else {
    return i;
  }
}

function advance_input_n(param, i, n, dir0) {
  const pref = i._1;
  const next = i._0;
  if (dir0 === /* Forward */ 0) {
    const nnext = skipn(n, next);
    const read = firstn(n, next);
    return {
      TAG: /* Input */ 0,
      _0: nnext,
      _1: app(rev(read), pref)
    };
  }
  const npref = skipn(n, pref);
  const read$1 = firstn(n, pref);
  return {
    TAG: /* Input */ 0,
    _0: app(rev(read$1), next),
    _1: npref
  };
}

function eq_dec$2(n, m) {
  if (Curry._1($$BigInt.equal(n), $$BigInt.zero)) {
    if (Curry._1($$BigInt.equal(m), $$BigInt.zero)) {
      return true;
    } else {
      Warblre_js__BigInt.Nat.pred(m);
      return false;
    }
  } else {
    let n0 = Warblre_js__BigInt.Nat.pred(n);
    if (Curry._1($$BigInt.equal(m), $$BigInt.zero)) {
      return false;
    } else {
      return eq_dec$2(n0, Warblre_js__BigInt.Nat.pred(m));
    }
  }
}

const GroupId = {
  eq_dec: eq_dec$2
};

function compare(x, y) {
  const compare0 = function (n, m) {
    if (Curry._1($$BigInt.equal(n), $$BigInt.zero)) {
      if (Curry._1($$BigInt.equal(m), $$BigInt.zero)) {
        return /* Eq */ 0;
      } else {
        Warblre_js__BigInt.Nat.pred(m);
        return /* Lt */ 1;
      }
    } else {
      let n$p = Warblre_js__BigInt.Nat.pred(n);
      if (Curry._1($$BigInt.equal(m), $$BigInt.zero)) {
        return /* Gt */ 2;
      } else {
        return compare0(n$p, Warblre_js__BigInt.Nat.pred(m));
      }
    }
  };
  const c = compareSpec2Type(compare0(x, y));
  switch (c) {
    case /* CompEqT */ 0 :
      return /* EQ */ 1;
    case /* CompLtT */ 1 :
      return /* LT */ 0;
    case /* CompGtT */ 2 :
      return /* GT */ 2;
  }
}

const GroupId$p = {
  eq_dec: eq_dec$2,
  compare: compare
};

const TO = {};

const IsTO = {};

const OrderTac = {};

function lt_dec(x, y) {
  const match = compare(x, y);
  switch (match) {
    case /* LT */ 0 :
      return true;
    case /* EQ */ 1 :
    case /* GT */ 2 :
      return false;
  }
}

function eqb$1(x, y) {
  if (eq_dec$2(x, y)) {
    return true;
  } else {
    return false;
  }
}

const MX = {
  TO: TO,
  IsTO: IsTO,
  OrderTac: OrderTac,
  eq_dec: eq_dec$2,
  lt_dec: lt_dec,
  eqb: eqb$1
};

const TO$1 = {};

const IsTO$1 = {};

const OrderTac$1 = {};

function lt_dec$1(x, y) {
  const match = compare(x, y);
  switch (match) {
    case /* LT */ 0 :
      return true;
    case /* EQ */ 1 :
    case /* GT */ 2 :
      return false;
  }
}

function eqb$2(x, y) {
  if (eq_dec$2(x, y)) {
    return true;
  } else {
    return false;
  }
}

const MO = {
  TO: TO$1,
  IsTO: IsTO$1,
  OrderTac: OrderTac$1,
  eq_dec: eq_dec$2,
  lt_dec: lt_dec$1,
  eqb: eqb$2
};

const PX = {
  MO: MO
};

function is_empty(param) {
  if (param) {
    return false;
  } else {
    return true;
  }
}

function mem(k, _param) {
  while (true) {
    const param = _param;
    if (!param) {
      return false;
    }
    const match = compare(k, param.hd[0]);
    switch (match) {
      case /* LT */ 0 :
        return false;
      case /* EQ */ 1 :
        return true;
      case /* GT */ 2 :
        _param = param.tl;
        continue;
    }
  };
}

function find(k, _param) {
  while (true) {
    const param = _param;
    if (!param) {
      return;
    }
    const p = param.hd;
    const match = compare(k, p[0]);
    switch (match) {
      case /* LT */ 0 :
        return;
      case /* EQ */ 1 :
        return Caml_option.some(p[1]);
      case /* GT */ 2 :
        _param = param.tl;
        continue;
    }
  };
}

function add(k, x, s) {
  if (!s) {
    return {
      hd: [
        k,
        x
      ],
      tl: /* [] */ 0
    };
  }
  const p = s.hd;
  const k$p = p[0];
  const l = s.tl;
  const match = compare(k, k$p);
  switch (match) {
    case /* LT */ 0 :
      return {
        hd: [
          k,
          x
        ],
        tl: s
      };
    case /* EQ */ 1 :
      return {
        hd: [
          k,
          x
        ],
        tl: l
      };
    case /* GT */ 2 :
      return {
        hd: [
          k$p,
          p[1]
        ],
        tl: add(k, x, l)
      };
  }
}

function remove(k, s) {
  if (!s) {
    return /* [] */ 0;
  }
  const p = s.hd;
  const k$p = p[0];
  const l = s.tl;
  const match = compare(k, k$p);
  switch (match) {
    case /* LT */ 0 :
      return s;
    case /* EQ */ 1 :
      return l;
    case /* GT */ 2 :
      return {
        hd: [
          k$p,
          p[1]
        ],
        tl: remove(k, l)
      };
  }
}

function elements(m) {
  return m;
}

function fold(f, _m, _acc) {
  while (true) {
    const acc = _acc;
    const m = _m;
    if (!m) {
      return acc;
    }
    const p = m.hd;
    _acc = Curry._3(f, p[0], p[1], acc);
    _m = m.tl;
    continue;
  };
}

function equal(cmp, _m, _m$p) {
  while (true) {
    const m$p = _m$p;
    const m = _m;
    if (!m) {
      if (m$p) {
        return false;
      } else {
        return true;
      }
    }
    if (!m$p) {
      return false;
    }
    const p0 = m$p.hd;
    const p = m.hd;
    const match = compare(p[0], p0[0]);
    switch (match) {
      case /* EQ */ 1 :
        if (!Curry._2(cmp, p[1], p0[1])) {
          return false;
        }
        _m$p = m$p.tl;
        _m = m.tl;
        continue;
      case /* LT */ 0 :
      case /* GT */ 2 :
        return false;
    }
  };
}

function map$1(f, param) {
  if (!param) {
    return /* [] */ 0;
  }
  const p = param.hd;
  return {
    hd: [
      p[0],
      Curry._1(f, p[1])
    ],
    tl: map$1(f, param.tl)
  };
}

function mapi(f, param) {
  if (!param) {
    return /* [] */ 0;
  }
  const p = param.hd;
  const k = p[0];
  return {
    hd: [
      k,
      Curry._2(f, k, p[1])
    ],
    tl: mapi(f, param.tl)
  };
}

function option_cons(k, o, l) {
  if (o !== undefined) {
    return {
      hd: [
        k,
        Caml_option.valFromOption(o)
      ],
      tl: l
    };
  } else {
    return l;
  }
}

function map2_l(f, param) {
  if (!param) {
    return /* [] */ 0;
  }
  const p = param.hd;
  return option_cons(p[0], Curry._2(f, Caml_option.some(p[1]), undefined), map2_l(f, param.tl));
}

function map2_r(f, param) {
  if (!param) {
    return /* [] */ 0;
  }
  const p = param.hd;
  return option_cons(p[0], Curry._2(f, undefined, Caml_option.some(p[1])), map2_r(f, param.tl));
}

function map2(f, m) {
  if (!m) {
    return function (param) {
      return map2_r(f, param);
    };
  }
  const p = m.hd;
  const e = p[1];
  const k = p[0];
  const l = m.tl;
  const map2_aux = function (m$p) {
    if (!m$p) {
      return map2_l(f, m);
    }
    const p0 = m$p.hd;
    const e$p = p0[1];
    const k$p = p0[0];
    const l$p = m$p.tl;
    const match = compare(k, k$p);
    switch (match) {
      case /* LT */ 0 :
        return option_cons(k, Curry._2(f, Caml_option.some(e), undefined), map2(f, l)(m$p));
      case /* EQ */ 1 :
        return option_cons(k, Curry._2(f, Caml_option.some(e), Caml_option.some(e$p)), map2(f, l)(l$p));
      case /* GT */ 2 :
        return option_cons(k$p, Curry._2(f, undefined, Caml_option.some(e$p)), map2_aux(l$p));
    }
  };
  return map2_aux;
}

function combine(m) {
  if (!m) {
    return function (param) {
      return map$1((function (e$p) {
        return [
          undefined,
          Caml_option.some(e$p)
        ];
      }), param);
    };
  }
  const p = m.hd;
  const e = p[1];
  const k = p[0];
  const l = m.tl;
  const combine_aux = function (m$p) {
    if (!m$p) {
      return map$1((function (e0) {
        return [
          Caml_option.some(e0),
          undefined
        ];
      }), m);
    }
    const p0 = m$p.hd;
    const e$p = p0[1];
    const k$p = p0[0];
    const l$p = m$p.tl;
    const match = compare(k, k$p);
    switch (match) {
      case /* LT */ 0 :
        return {
          hd: [
            k,
            [
              Caml_option.some(e),
              undefined
            ]
          ],
          tl: combine(l)(m$p)
        };
      case /* EQ */ 1 :
        return {
          hd: [
            k,
            [
              Caml_option.some(e),
              Caml_option.some(e$p)
            ]
          ],
          tl: combine(l)(l$p)
        };
      case /* GT */ 2 :
        return {
          hd: [
            k$p,
            [
              undefined,
              Caml_option.some(e$p)
            ]
          ],
          tl: combine_aux(l$p)
        };
    }
  };
  return combine_aux;
}

function fold_right_pair(f, l, i) {
  return fold_right((function (p) {
    return Curry._2(f, fst(p), snd(p));
  }), i, l);
}

function map2_alt(f, m, m$p) {
  const m0 = combine(m)(m$p);
  const m1 = map$1((function (p) {
    return Curry._2(f, fst(p), snd(p));
  }), m0);
  return fold_right_pair(option_cons, m1, /* [] */ 0);
}

function at_least_one(o, o$p) {
  if (o !== undefined || o$p !== undefined) {
    return [
      o,
      o$p
    ];
  }
  
}

function at_least_one_then_f(f, o, o$p) {
  if (o !== undefined || o$p !== undefined) {
    return Curry._2(f, o, o$p);
  }
  
}

const Raw = {
  MX: MX,
  PX: PX,
  empty: /* [] */ 0,
  is_empty: is_empty,
  mem: mem,
  find: find,
  add: add,
  remove: remove,
  elements: elements,
  fold: fold,
  equal: equal,
  map: map$1,
  mapi: mapi,
  option_cons: option_cons,
  map2_l: map2_l,
  map2_r: map2_r,
  map2: map2,
  combine: combine,
  fold_right_pair: fold_right_pair,
  map2_alt: map2_alt,
  at_least_one: at_least_one,
  at_least_one_then_f: at_least_one_then_f
};

const M = {
  Raw: Raw
};

function $$this(s) {
  return s;
}

function coq_open(currIdx, gid) {
  const partial_arg = {
    startIdx: currIdx,
    endIdx: undefined
  };
  return function (param) {
    return add(gid, partial_arg, param);
  };
}

function close(currIdx, gid, gm0) {
  const r = find(gid, gm0);
  if (r === undefined) {
    return gm0;
  }
  const startIdx0 = r.startIdx;
  if (Curry._1($$BigInt.le(startIdx0), currIdx)) {
    return add(gid, {
      startIdx: startIdx0,
      endIdx: Caml_option.some(currIdx)
    }, gm0);
  } else {
    return add(gid, {
      startIdx: currIdx,
      endIdx: Caml_option.some(startIdx0)
    }, gm0);
  }
}

function reset(param, param$1) {
  return fold_left((function (s, gid) {
    return remove(gid, s);
  }), param, param$1);
}

function update(currIdx, g) {
  switch (g.TAG) {
    case /* Open */ 0 :
      return coq_open(currIdx, g._0);
    case /* Close */ 1 :
      const g$1 = g._0;
      return function (param) {
        return close(currIdx, g$1, param);
      };
    case /* Reset */ 2 :
      const partial_arg = g._0;
      return function (param) {
        return reset(partial_arg, param);
      };
  }
}

function lk_dir(param) {
  switch (param) {
    case /* LookAhead */ 0 :
    case /* NegLookAhead */ 2 :
      return /* Forward */ 0;
    case /* LookBehind */ 1 :
    case /* NegLookBehind */ 3 :
      return /* Backward */ 1;
  }
}

function positivity(param) {
  switch (param) {
    case /* LookAhead */ 0 :
    case /* LookBehind */ 1 :
      return true;
    case /* NegLookAhead */ 2 :
    case /* NegLookBehind */ 3 :
      return false;
  }
}

function def_groups(params, _param) {
  while (true) {
    const param = _param;
    if (/* tag */ typeof param === "number" || typeof param === "string") {
      return /* [] */ 0;
    }
    switch (param.TAG) {
      case /* Disjunction0 */ 1 :
      case /* Sequence */ 2 :
        break;
      case /* Quantified0 */ 3 :
        _param = param._3;
        continue;
      case /* Lookaround */ 4 :
        _param = param._1;
        continue;
      case /* Group0 */ 5 :
        return {
          hd: param._0,
          tl: def_groups(params, param._1)
        };
      default:
        return /* [] */ 0;
    }
    return app(def_groups(params, param._0), def_groups(params, param._1));
  };
}

function max_group(params, _param) {
  while (true) {
    const param = _param;
    if (/* tag */ typeof param === "number" || typeof param === "string") {
      return $$BigInt.zero;
    }
    switch (param.TAG) {
      case /* Disjunction0 */ 1 :
      case /* Sequence */ 2 :
        break;
      case /* Quantified0 */ 3 :
        _param = param._3;
        continue;
      case /* Lookaround */ 4 :
        _param = param._1;
        continue;
      case /* Group0 */ 5 :
        return Curry._1($$BigInt.max(param._0), max_group(params, param._1));
      default:
        return $$BigInt.zero;
    }
    return Curry._1($$BigInt.max(max_group(params, param._0)), max_group(params, param._1));
  };
}

function lazy_star(param, r) {
  return {
    TAG: /* Quantified0 */ 3,
    _0: false,
    _1: $$BigInt.zero,
    _2: /* Inf */ 0,
    _3: r
  };
}

function dot_star(params) {
  return lazy_star(params, {
    TAG: /* Character */ 0,
    _0: /* CdAll */ 2
  });
}

function lazy_prefix(params, r) {
  return {
    TAG: /* Sequence */ 2,
    _0: lazy_star(params, {
      TAG: /* Character */ 0,
      _0: /* CdAll */ 2
    }),
    _1: r
  };
}

function seqop(o1, o2) {
  if (o1 !== undefined) {
    return o1;
  } else {
    return o2;
  }
}

const Coq__1 = {};

function tree_res(params, _t0, _gm0, _inp0, dir0) {
  while (true) {
    const inp0 = _inp0;
    const gm0 = _gm0;
    const t0 = _t0;
    if (/* tag */ typeof t0 === "number" || typeof t0 === "string") {
      if (t0 === /* Mismatch */ 0) {
        return;
      } else {
        return [
          inp0,
          gm0
        ];
      }
    }
    switch (t0.TAG) {
      case /* Choice */ 0 :
        return seqop(tree_res(params, t0._0, gm0, inp0, dir0), tree_res(params, t0._1, gm0, inp0, dir0));
      case /* Read */ 1 :
        _inp0 = advance_input$p(params, inp0, dir0);
        _t0 = t0._1;
        continue;
      case /* ReadBackRef */ 2 :
        _inp0 = advance_input_n(params, inp0, length(t0._0), dir0);
        _t0 = t0._1;
        continue;
      case /* Progress */ 3 :
        _t0 = t0._0;
        continue;
      case /* AnchorPass */ 4 :
        _t0 = t0._1;
        continue;
      case /* GroupAction */ 5 :
        _gm0 = update(idx(params, inp0), t0._0)(gm0);
        _t0 = t0._1;
        continue;
      case /* LK */ 6 :
        const t1 = t0._2;
        const tlk = t0._1;
        const lk = t0._0;
        if (positivity(lk)) {
          const l = tree_res(params, tlk, gm0, inp0, lk_dir(lk));
          if (l === undefined) {
            return;
          }
          _gm0 = l[1];
          _t0 = t1;
          continue;
        }
        const match = tree_res(params, tlk, gm0, inp0, lk_dir(lk));
        if (match !== undefined) {
          return;
        }
        _t0 = t1;
        continue;
      case /* LKFail */ 7 :
        return;
    }
  };
}

function strict_suffix_forward(params, inp0, _next, _pref) {
  while (true) {
    const pref = _pref;
    const next = _next;
    if (!next) {
      return false;
    }
    const next$p = next.tl;
    const c = next.hd;
    if (eqb((function (param, param$1) {
        return input_eq_dec(params, param, param$1);
      }), {
        TAG: /* Input */ 0,
        _0: next$p,
        _1: {
          hd: c,
          tl: pref
        }
      }, inp0)) {
      return true;
    }
    _pref = {
      hd: c,
      tl: pref
    };
    _next = next$p;
    continue;
  };
}

function strict_suffix_backward(params, inp0, _next, _param) {
  while (true) {
    const param = _param;
    const next = _next;
    if (!param) {
      return false;
    }
    const pref$p = param.tl;
    const c = param.hd;
    if (eqb((function (param, param$1) {
        return input_eq_dec(params, param, param$1);
      }), {
        TAG: /* Input */ 0,
        _0: {
          hd: c,
          tl: next
        },
        _1: pref$p
      }, inp0)) {
      return true;
    }
    _param = pref$p;
    _next = {
      hd: c,
      tl: next
    };
    continue;
  };
}

function is_strict_suffix(params, inp1, inp2, dir0) {
  const pref2 = inp2._1;
  const next2 = inp2._0;
  if (dir0 === /* Forward */ 0) {
    return strict_suffix_forward(params, inp1, next2, pref2);
  } else {
    return strict_suffix_backward(params, inp1, next2, pref2);
  }
}

function read_backref(params, rer, gm0, gid, inp0, dir0) {
  const r = find(gid, gm0);
  if (r === undefined) {
    return [
      /* [] */ 0,
      inp0
    ];
  }
  const endIdx0 = r.endIdx;
  if (endIdx0 === undefined) {
    return [
      /* [] */ 0,
      inp0
    ];
  }
  const endIdx1 = Caml_option.valFromOption(endIdx0);
  const startIdx0 = r.startIdx;
  const sub_can = map(Curry._1(params.char.canonicalize, rer), substr(params, inp0, startIdx0, endIdx1));
  const len = Curry._1(sub(endIdx1), startIdx0);
  const pref = inp0._1;
  const next = inp0._0;
  if (dir0 === /* Forward */ 0) {
    const r0 = length(next);
    const r1 = Warblre_js__BigInt.Nat.succ(r0);
    if (Curry._1($$BigInt.le(r1), len)) {
      return;
    }
    const firstn0 = firstn(len, next);
    if (eqb((function (param, param$1) {
        return string_eq_dec(params, param, param$1);
      }), map(Curry._1(params.char.canonicalize, rer), firstn0), sub_can)) {
      return [
        firstn0,
        advance_input_n(params, inp0, len, /* Forward */ 0)
      ];
    } else {
      return;
    }
  } else {
    const r0$1 = length(pref);
    const r1$1 = Warblre_js__BigInt.Nat.succ(r0$1);
    if (Curry._1($$BigInt.le(r1$1), len)) {
      return;
    }
    const rev_firstn = rev(firstn(len, pref));
    if (eqb((function (param, param$1) {
        return string_eq_dec(params, param, param$1);
      }), map(Curry._1(params.char.canonicalize, rer), rev_firstn), sub_can)) {
      return [
        rev_firstn,
        advance_input_n(params, inp0, len, /* Backward */ 1)
      ];
    } else {
      return;
    }
  }
}

function lk_result(params, lk, t0, gm0, inp0) {
  if (positivity(lk)) {
    const l = tree_res(params, t0, gm0, inp0, lk_dir(lk));
    if (l !== undefined) {
      return l[1];
    } else {
      return;
    }
  }
  const match = tree_res(params, t0, gm0, inp0, lk_dir(lk));
  if (match !== undefined) {
    return;
  } else {
    return gm0;
  }
}

function is_boundary(params, rer, param) {
  const pref = param._1;
  const next = param._0;
  if (!next) {
    if (pref) {
      return word_char(params, rer, pref.hd);
    } else {
      return false;
    }
  }
  const c1 = next.hd;
  if (pref) {
    return xorb(word_char(params, rer, c1), word_char(params, rer, pref.hd));
  } else {
    return word_char(params, rer, c1);
  }
}

function is_input_boundary(params, multiline0, param) {
  if (param) {
    if (multiline0) {
      return inb(params.char.eq_dec, param.hd, params.char.line_terminators);
    } else {
      return false;
    }
  } else {
    return true;
  }
}

function anchor_satisfied(params, rer, a, i) {
  const pref = i._1;
  const next = i._0;
  switch (a) {
    case /* BeginInput */ 0 :
      return is_input_boundary(params, rer.multiline, pref);
    case /* EndInput */ 1 :
      return is_input_boundary(params, rer.multiline, next);
    case /* WordBoundary0 */ 2 :
      return is_boundary(params, rer, i);
    case /* NonWordBoundary */ 3 :
      const param = is_boundary(params, rer, i);
      if (param) {
        return false;
      } else {
        return true;
      }
    case /* BeginBuffer */ 4 :
      if (pref) {
        return false;
      } else {
        return true;
      }
    case /* EndBuffer */ 5 :
      if (next) {
        return false;
      } else {
        return true;
      }
    case /* TerminatedBuffer */ 6 :
      if (!next) {
        return true;
      }
      const l = next.tl;
      const c1 = next.hd;
      if (l) {
        if (l.tl || !eqb(params.char.eq_dec, c1, coq_CARRIAGE_RETURN(lWParameters(params)))) {
          return false;
        } else {
          return eqb(params.char.eq_dec, l.hd, coq_LINE_FEED(lWParameters(params)));
        }
      } else {
        return Curry._2(lWParameters(params).set_class.contains, line_terminators$1(lWParameters(params)), c1);
      }
  }
}

function seq_list(param, r1, r2, param$1) {
  if (param$1 === /* Forward */ 0) {
    return {
      hd: {
        TAG: /* Areg */ 0,
        _0: r1
      },
      tl: {
        hd: {
          TAG: /* Areg */ 0,
          _0: r2
        },
        tl: /* [] */ 0
      }
    };
  } else {
    return {
      hd: {
        TAG: /* Areg */ 0,
        _0: r2
      },
      tl: {
        hd: {
          TAG: /* Areg */ 0,
          _0: r1
        },
        tl: /* [] */ 0
      }
    };
  }
}

function noi_pred(x) {
  if (/* tag */ typeof x === "number" || typeof x === "string") {
    return /* Inf */ 0;
  } else {
    return {
      TAG: /* N */ 0,
      _0: Curry._1(sub(x._0), Warblre_js__BigInt.Nat.succ($$BigInt.zero))
    };
  }
}

function patname_eq_dec(params, _x, _y) {
  while (true) {
    const y = _y;
    const x = _x;
    if (!x) {
      if (y) {
        return false;
      } else {
        return true;
      }
    }
    if (!y) {
      return false;
    }
    if (!Curry._2(params.char.eq_dec, x.hd, y.hd)) {
      return false;
    }
    _y = y.tl;
    _x = x.tl;
    continue;
  };
}

function patname_eqb(params, n1, n2) {
  if (patname_eq_dec(params, n1, n2)) {
    return true;
  } else {
    return false;
  }
}

function nameidx(params, nm, name) {
  return findA((function (n) {
    return patname_eqb(params, n, name);
  }), nm);
}

function buildnm$p(params, _wr, _nm, _n) {
  while (true) {
    const n = _n;
    const nm = _nm;
    const wr = _wr;
    let exit = 0;
    if (/* tag */ typeof wr === "number" || typeof wr === "string") {
      return [
        nm,
        n
      ];
    }
    switch (wr.TAG) {
      case /* Disjunction */ 3 :
      case /* Seq */ 5 :
        exit = 1;
        break;
      case /* Group */ 6 :
        const wr1 = wr._1;
        const name0 = wr._0;
        if (name0 !== undefined) {
          _n = Warblre_js__BigInt.Nat.succ(n);
          _nm = {
            hd: [
              Caml_option.valFromOption(name0),
              Warblre_js__BigInt.Nat.succ(n)
            ],
            tl: nm
          };
          _wr = wr1;
          continue;
        }
        _n = Warblre_js__BigInt.Nat.succ(n);
        _wr = wr1;
        continue;
      case /* Quantified */ 4 :
      case /* Lookahead */ 7 :
      case /* NegativeLookahead */ 8 :
      case /* Lookbehind */ 9 :
      case /* NegativeLookbehind */ 10 :
        exit = 2;
        break;
      default:
        return [
          nm,
          n
        ];
    }
    switch (exit) {
      case 1 :
        const match = buildnm$p(params, wr._0, nm, n);
        _n = match[1];
        _nm = match[0];
        _wr = wr._1;
        continue;
      case 2 :
        _wr = wr._0;
        continue;
    }
  };
}

function buildnm(params, wr) {
  return fst(buildnm$p(params, wr, /* [] */ 0, $$BigInt.zero));
}

function num_groups(params, _param) {
  while (true) {
    const param = _param;
    if (/* tag */ typeof param === "number" || typeof param === "string") {
      return $$BigInt.zero;
    }
    switch (param.TAG) {
      case /* Disjunction0 */ 1 :
      case /* Sequence */ 2 :
        break;
      case /* Quantified0 */ 3 :
        _param = param._3;
        continue;
      case /* Lookaround */ 4 :
        _param = param._1;
        continue;
      case /* Group0 */ 5 :
        return Warblre_js__BigInt.Nat.succ(num_groups(params, param._1));
      default:
        return $$BigInt.zero;
    }
    return Curry._1($$BigInt.add(num_groups(params, param._0)), num_groups(params, param._1));
  };
}

function unicodeCodePoint(head, tail) {
  const lead = to_integer_4(head);
  const trail = to_integer_4(tail);
  return utf16SurrogatePair(lead, trail);
}

function characterClassEsc_to_linden(param, p) {
  if (!/* tag */ (typeof p === "number" || typeof p === "string")) {
    if (p.TAG === /* UnicodeProp */ 0) {
      return {
        TAG: /* CdUnicodeProp */ 1,
        _0: p._0
      };
    } else {
      return {
        TAG: /* CdNonUnicodeProp */ 2,
        _0: p._0
      };
    }
  }
  switch (p) {
    case /* Coq_esc_d */ 0 :
      return /* CdDigits */ 3;
    case /* Coq_esc_D */ 1 :
      return /* CdNonDigits */ 4;
    case /* Coq_esc_s */ 2 :
      return /* CdWhitespace */ 5;
    case /* Coq_esc_S */ 3 :
      return /* CdNonWhitespace */ 6;
    case /* Coq_esc_w */ 4 :
      return /* CdWordChar */ 7;
    case /* Coq_esc_W */ 5 :
      return /* CdNonWordChar */ 8;
  }
}

function controlEsc_singleCharacter_numValue(params, param) {
  switch (param) {
    case /* Coq_esc_f */ 0 :
      return Curry._1(lWParameters(params).character_class.numeric_value, coq_FORM_FEED(lWParameters(params)));
    case /* Coq_esc_n */ 1 :
      return Curry._1(lWParameters(params).character_class.numeric_value, coq_LINE_FEED(lWParameters(params)));
    case /* Coq_esc_r */ 2 :
      return Curry._1(lWParameters(params).character_class.numeric_value, coq_CARRIAGE_RETURN(lWParameters(params)));
    case /* Coq_esc_t */ 3 :
      return Curry._1(lWParameters(params).character_class.numeric_value, coq_CHARACTER_TABULATION(lWParameters(params)));
    case /* Coq_esc_v */ 4 :
      return Curry._1(lWParameters(params).character_class.numeric_value, coq_LINE_TABULATION(lWParameters(params)));
  }
}

function asciiEsc_singleCharacter_numValue(l) {
  return Curry._1($$BigInt.rem(numeric_value$1(l)), Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ(Warblre_js__BigInt.Nat.succ($$BigInt.zero)))))))))))))))))))))))))))))))));
}

function characterEscape_singleCharacter_numValue(params, esc0) {
  if (/* tag */ typeof esc0 === "number" || typeof esc0 === "string") {
    const specParameters = lWParameters(params);
    return Curry._1(lWParameters(params).character_class.numeric_value, Curry._1(specParameters.character_class.from_numeric_value, $$BigInt.zero));
  }
  switch (esc0.TAG) {
    case /* ControlEsc */ 0 :
      return controlEsc_singleCharacter_numValue(params, esc0._0);
    case /* AsciiControlEsc */ 1 :
      return asciiEsc_singleCharacter_numValue(esc0._0);
    case /* HexEscape */ 2 :
      return to_integer_2(esc0._0, esc0._1);
    case /* UnicodeEsc */ 3 :
      const seq = esc0._0;
      switch (seq.TAG) {
        case /* Pair */ 0 :
          return unicodeCodePoint(seq._0, seq._1);
        case /* Lonely */ 1 :
          return to_integer_4(seq._0);
        case /* CodePoint */ 2 :
          return Curry._1(params.char.numeric_value, seq._0);
      }
    case /* IdentityEsc */ 4 :
      return Curry._1(params.char.numeric_value, esc0._0);
  }
}

function characterEscape_to_linden(params, esc) {
  const c = characterEscape_singleCharacter_numValue(params, esc);
  return {
    TAG: /* CdSingle */ 0,
    _0: Curry._1(params.char.from_numeric_value, c)
  };
}

function atomesc_to_linden(params, ae, nm) {
  switch (ae.TAG) {
    case /* DecimalEsc */ 0 :
      return Interop.success({
        TAG: /* Backreference */ 7,
        _0: ae._0
      });
    case /* ACharacterClassEsc */ 1 :
      const cd = characterClassEsc_to_linden(params, ae._0);
      return Interop.success({
        TAG: /* Character */ 0,
        _0: cd
      });
    case /* ACharacterEsc */ 2 :
      const cd$1 = characterEscape_to_linden(params, ae._0);
      return Interop.success({
        TAG: /* Character */ 0,
        _0: cd$1
      });
    case /* GroupEsc */ 3 :
      const gid = nameidx(params, nm, ae._0);
      if (gid !== undefined) {
        return Interop.success({
          TAG: /* Backreference */ 7,
          _0: Caml_option.valFromOption(gid)
        });
      } else {
        return Interop.error(/* WlMalformed */ 0);
      }
  }
}

function classEscape_to_linden(params, esc0) {
  if (/* tag */ typeof esc0 === "number" || typeof esc0 === "string") {
    if (esc0 === /* Coq_esc_b */ 0) {
      return {
        TAG: /* CdSingle */ 0,
        _0: coq_BACKSPACE(lWParameters(params))
      };
    } else {
      return {
        TAG: /* CdSingle */ 0,
        _0: coq_HYPHEN_MINUS(lWParameters(params))
      };
    }
  } else if (esc0.TAG === /* CCharacterClassEsc */ 0) {
    return characterClassEsc_to_linden(params, esc0._0);
  } else {
    return characterEscape_to_linden(params, esc0._0);
  }
}

function classEscape_singleCharacter_numValue(params, esc0) {
  if (/* tag */ typeof esc0 === "number" || typeof esc0 === "string") {
    if (esc0 === /* Coq_esc_b */ 0) {
      return Interop.success(Curry._1(lWParameters(params).character_class.numeric_value, coq_BACKSPACE(lWParameters(params))));
    } else {
      return Interop.success(Curry._1(lWParameters(params).character_class.numeric_value, coq_HYPHEN_MINUS(lWParameters(params))));
    }
  } else if (esc0.TAG === /* CCharacterClassEsc */ 0) {
    return Interop.error(/* WlMalformed */ 0);
  } else {
    return Interop.success(characterEscape_singleCharacter_numValue(params, esc0._0));
  }
}

function classAtom_to_linden(params, c) {
  if (c.TAG === /* SourceCharacter */ 0) {
    return {
      TAG: /* CdSingle */ 0,
      _0: c._0
    };
  } else {
    return classEscape_to_linden(params, c._0);
  }
}

function classAtom_singleCharacter_numValue(params, c) {
  if (c.TAG === /* SourceCharacter */ 0) {
    return Interop.success(Curry._1(params.char.numeric_value, c._0));
  } else {
    return classEscape_singleCharacter_numValue(params, c._0);
  }
}

function classRanges_to_linden(params, param) {
  if (/* tag */ typeof param === "number" || typeof param === "string") {
    return Interop.success(/* CdEmpty */ 0);
  }
  if (param.TAG === /* ClassAtomCR */ 0) {
    const t0 = param._1;
    const ca = param._0;
    if (/* tag */ typeof t0 === "number" || typeof t0 === "string") {
      return Interop.success(classAtom_to_linden(params, ca));
    }
    t0.TAG === /* ClassAtomCR */ 0;
    const cda = classAtom_to_linden(params, ca);
    const cdt = classRanges_to_linden(params, t0);
    return Interop.success({
      TAG: /* CdUnion */ 5,
      _0: cda,
      _1: cdt
    });
  }
  const t0$1 = param._2;
  const h = param._1;
  const l = param._0;
  if (/* tag */ typeof t0$1 === "number" || typeof t0$1 === "string") {
    let cl = classAtom_singleCharacter_numValue(params, l);
    let ch = classAtom_singleCharacter_numValue(params, h);
    if (Curry._1($$BigInt.le(cl), ch)) {
      return Interop.success({
        TAG: /* CdRange */ 4,
        _0: Curry._1(params.char.from_numeric_value, cl),
        _1: Curry._1(params.char.from_numeric_value, ch)
      });
    } else {
      return Interop.error(/* WlMalformed */ 0);
    }
  }
  t0$1.TAG === /* ClassAtomCR */ 0;
  let cl$1 = classAtom_singleCharacter_numValue(params, l);
  let ch$1 = classAtom_singleCharacter_numValue(params, h);
  let cdt$1 = classRanges_to_linden(params, t0$1);
  if (Curry._1($$BigInt.le(cl$1), ch$1)) {
    return Interop.success({
      TAG: /* CdUnion */ 5,
      _0: {
        TAG: /* CdRange */ 4,
        _0: Curry._1(params.char.from_numeric_value, cl$1),
        _1: Curry._1(params.char.from_numeric_value, ch$1)
      },
      _1: cdt$1
    });
  } else {
    return Interop.error(/* WlMalformed */ 0);
  }
}

function charclass_to_linden(params, crs) {
  if (crs.TAG === /* NoninvertedCC */ 0) {
    return classRanges_to_linden(params, crs._0);
  }
  const cd = classRanges_to_linden(params, crs._0);
  return Interop.success({
    TAG: /* CdInv */ 3,
    _0: cd
  });
}

function wquantpref_to_linden(param, n) {
  if (/* tag */ typeof n === "number" || typeof n === "string") {
    switch (n) {
      case /* Star */ 0 :
        return Interop.success(function (greedy, x) {
          return {
            TAG: /* Quantified0 */ 3,
            _0: greedy,
            _1: $$BigInt.zero,
            _2: /* Inf */ 0,
            _3: x
          };
        });
      case /* Plus */ 1 :
        return Interop.success(function (greedy, x) {
          return {
            TAG: /* Quantified0 */ 3,
            _0: greedy,
            _1: Warblre_js__BigInt.Nat.succ($$BigInt.zero),
            _2: /* Inf */ 0,
            _3: x
          };
        });
      case /* Question */ 2 :
        return Interop.success(function (greedy, x) {
          return {
            TAG: /* Quantified0 */ 3,
            _0: greedy,
            _1: $$BigInt.zero,
            _2: {
              TAG: /* N */ 0,
              _0: Warblre_js__BigInt.Nat.succ($$BigInt.zero)
            },
            _3: x
          };
        });
    }
  } else {
    switch (n.TAG) {
      case /* RepExact */ 0 :
        const n$1 = n._0;
        return Interop.success(function (greedy, x) {
          return {
            TAG: /* Quantified0 */ 3,
            _0: greedy,
            _1: n$1,
            _2: {
              TAG: /* N */ 0,
              _0: $$BigInt.zero
            },
            _3: x
          };
        });
      case /* RepPartialRange */ 1 :
        const n$2 = n._0;
        return Interop.success(function (greedy, x) {
          return {
            TAG: /* Quantified0 */ 3,
            _0: greedy,
            _1: n$2,
            _2: /* Inf */ 0,
            _3: x
          };
        });
      case /* RepRange */ 2 :
        const maxi = n._1;
        const mini = n._0;
        if (Curry._1($$BigInt.le(mini), maxi)) {
          return Interop.success(function (greedy, x) {
            return {
              TAG: /* Quantified0 */ 3,
              _0: greedy,
              _1: mini,
              _2: {
                TAG: /* N */ 0,
                _0: Curry._1(sub(maxi), mini)
              },
              _3: x
            };
          });
        } else {
          return Interop.error(/* WlMalformed */ 0);
        }
    }
  }
}

function assert_idx_eq(i1, i2) {
  if (Curry._1($$BigInt.equal(i1), i2)) {
    return Interop.success(undefined);
  } else {
    return Interop.error(/* WlMalformed */ 0);
  }
}

function warblre_to_linden(params, wr, n, nm) {
  if (/* tag */ typeof wr === "number" || typeof wr === "string") {
    switch (wr) {
      case /* Empty */ 0 :
        return Interop.success(/* Epsilon */ 0);
      case /* Dot */ 1 :
        return Interop.success({
          TAG: /* Character */ 0,
          _0: /* CdDot */ 1
        });
      case /* InputStart */ 2 :
        return Interop.success({
          TAG: /* Anchor */ 6,
          _0: /* BeginInput */ 0
        });
      case /* InputEnd */ 3 :
        return Interop.success({
          TAG: /* Anchor */ 6,
          _0: /* EndInput */ 1
        });
      case /* WordBoundary */ 4 :
        return Interop.success({
          TAG: /* Anchor */ 6,
          _0: /* WordBoundary0 */ 2
        });
      case /* NotWordBoundary */ 5 :
        return Interop.success({
          TAG: /* Anchor */ 6,
          _0: /* NonWordBoundary */ 3
        });
    }
  } else {
    switch (wr.TAG) {
      case /* Char */ 0 :
        return Interop.success({
          TAG: /* Character */ 0,
          _0: {
            TAG: /* CdSingle */ 0,
            _0: wr._0
          }
        });
      case /* AtomEsc */ 1 :
        return atomesc_to_linden(params, wr._0, nm);
      case /* CharacterClass */ 2 :
        const cd = charclass_to_linden(params, wr._0);
        return Interop.success({
          TAG: /* Character */ 0,
          _0: cd
        });
      case /* Disjunction */ 3 :
        const wr2 = wr._1;
        let lr1 = warblre_to_linden(params, wr._0, n, nm);
        const lr2 = warblre_to_linden(params, wr2, Curry._1($$BigInt.add(num_groups(params, lr1)), n), nm);
        return Interop.success({
          TAG: /* Disjunction0 */ 1,
          _0: lr1,
          _1: lr2
        });
      case /* Quantified */ 4 :
        const q = wr._1;
        const wr0 = wr._0;
        if (q.TAG === /* Greedy */ 0) {
          let quant = wquantpref_to_linden(params, q._0);
          const lr = warblre_to_linden(params, wr0, n, nm);
          return Interop.success(Curry._2(quant, true, lr));
        }
        let quant$1 = wquantpref_to_linden(params, q._0);
        const lr$1 = warblre_to_linden(params, wr0, n, nm);
        return Interop.success(Curry._2(quant$1, false, lr$1));
      case /* Seq */ 5 :
        const wr2$1 = wr._1;
        let lr1$1 = warblre_to_linden(params, wr._0, n, nm);
        const lr2$1 = warblre_to_linden(params, wr2$1, Curry._1($$BigInt.add(num_groups(params, lr1$1)), n), nm);
        return Interop.success({
          TAG: /* Sequence */ 2,
          _0: lr1$1,
          _1: lr2$1
        });
      case /* Group */ 6 :
        const wr0$1 = wr._1;
        const name0 = wr._0;
        if (name0 !== undefined) {
          const idx0 = nameidx(params, nm, name0);
          if (idx0 === undefined) {
            return Interop.error(/* WlMalformed */ 0);
          }
          assert_idx_eq(Caml_option.valFromOption(idx0), Warblre_js__BigInt.Nat.succ(n));
          let lr$2 = warblre_to_linden(params, wr0$1, Warblre_js__BigInt.Nat.succ(n), nm);
          return Interop.success({
            TAG: /* Group0 */ 5,
            _0: Warblre_js__BigInt.Nat.succ(n),
            _1: lr$2
          });
        }
        let lr$3 = warblre_to_linden(params, wr0$1, Warblre_js__BigInt.Nat.succ(n), nm);
        return Interop.success({
          TAG: /* Group0 */ 5,
          _0: Warblre_js__BigInt.Nat.succ(n),
          _1: lr$3
        });
      case /* Lookahead */ 7 :
        const lr$4 = warblre_to_linden(params, wr._0, n, nm);
        return Interop.success({
          TAG: /* Lookaround */ 4,
          _0: /* LookAhead */ 0,
          _1: lr$4
        });
      case /* NegativeLookahead */ 8 :
        const lr$5 = warblre_to_linden(params, wr._0, n, nm);
        return Interop.success({
          TAG: /* Lookaround */ 4,
          _0: /* NegLookAhead */ 2,
          _1: lr$5
        });
      case /* Lookbehind */ 9 :
        const lr$6 = warblre_to_linden(params, wr._0, n, nm);
        return Interop.success({
          TAG: /* Lookaround */ 4,
          _0: /* LookBehind */ 1,
          _1: lr$6
        });
      case /* NegativeLookbehind */ 10 :
        const lr$7 = warblre_to_linden(params, wr._0, n, nm);
        return Interop.success({
          TAG: /* Lookaround */ 4,
          _0: /* NegLookBehind */ 3,
          _1: lr$7
        });
    }
  }
}

const warblre_to_linden$p = warblre_to_linden;

function erase(params, _t0) {
  while (true) {
    const t0 = _t0;
    if (/* tag */ typeof t0 === "number" || typeof t0 === "string") {
      if (t0 === /* Mismatch */ 0) {
        return /* Mismatch */ 0;
      } else {
        return /* Match */ 1;
      }
    }
    switch (t0.TAG) {
      case /* Choice */ 0 :
        return {
          TAG: /* Choice */ 0,
          _0: erase(params, t0._0),
          _1: erase(params, t0._1)
        };
      case /* Read */ 1 :
        return {
          TAG: /* Read */ 1,
          _0: t0._0,
          _1: erase(params, t0._1)
        };
      case /* ReadBackRef */ 2 :
        return {
          TAG: /* ReadBackRef */ 2,
          _0: t0._0,
          _1: erase(params, t0._1)
        };
      case /* Progress */ 3 :
        return {
          TAG: /* Progress */ 3,
          _0: erase(params, t0._0)
        };
      case /* AnchorPass */ 4 :
        return {
          TAG: /* AnchorPass */ 4,
          _0: t0._0,
          _1: erase(params, t0._1)
        };
      case /* GroupAction */ 5 :
        return {
          TAG: /* GroupAction */ 5,
          _0: t0._0,
          _1: erase(params, t0._1)
        };
      case /* LK */ 6 :
        return {
          TAG: /* LK */ 6,
          _0: t0._0,
          _1: erase(params, t0._1),
          _2: erase(params, t0._2)
        };
      case /* LKFail */ 7 :
        return {
          TAG: /* LKFail */ 7,
          _0: t0._0,
          _1: erase(params, t0._1)
        };
      case /* Annot */ 8 :
        _t0 = t0._1;
        continue;
    }
  };
}

function greedy_choice(param, greedy, a, b) {
  if (greedy) {
    return {
      TAG: /* Choice */ 0,
      _0: a,
      _1: b
    };
  } else {
    return {
      TAG: /* Choice */ 0,
      _0: b,
      _1: a
    };
  }
}

function compute_tree(params, rer, act, inp0, gm0, dir0, fuel) {
  const fS = function (fuel0) {
    if (!act) {
      return /* Match */ 1;
    }
    const cont = act.tl;
    const a0 = act.hd;
    switch (a0.TAG) {
      case /* Areg */ 0 :
        const r = a0._0;
        if (/* tag */ typeof r === "number" || typeof r === "string") {
          return compute_tree(params, rer, cont, inp0, gm0, dir0, fuel0);
        }
        switch (r.TAG) {
          case /* Character */ 0 :
            const p = read_char(params, rer, r._0, inp0, dir0);
            if (p === undefined) {
              return /* Mismatch */ 0;
            }
            const treecont = compute_tree(params, rer, cont, p[1], gm0, dir0, fuel0);
            if (treecont !== undefined) {
              return {
                TAG: /* Read */ 1,
                _0: p[0],
                _1: treecont
              };
            } else {
              return;
            }
          case /* Disjunction0 */ 1 :
            const o = compute_tree(params, rer, {
              hd: {
                TAG: /* Areg */ 0,
                _0: r._0
              },
              tl: cont
            }, inp0, gm0, dir0, fuel0);
            const o0 = compute_tree(params, rer, {
              hd: {
                TAG: /* Areg */ 0,
                _0: r._1
              },
              tl: cont
            }, inp0, gm0, dir0, fuel0);
            if (o !== undefined && o0 !== undefined) {
              return {
                TAG: /* Choice */ 0,
                _0: o,
                _1: o0
              };
            } else {
              return;
            }
          case /* Sequence */ 2 :
            return compute_tree(params, rer, app(seq_list(params, r._0, r._1, dir0), cont), inp0, gm0, dir0, fuel0);
          case /* Quantified0 */ 3 :
            const r1 = r._3;
            const delta = r._2;
            const min0 = r._1;
            const greedy = r._0;
            if (Curry._1($$BigInt.equal(min0), $$BigInt.zero)) {
              if (/* tag */ typeof delta === "number" || typeof delta === "string") {
                const gidl = def_groups(params, r1);
                const o$1 = compute_tree(params, rer, {
                  hd: {
                    TAG: /* Areg */ 0,
                    _0: r1
                  },
                  tl: {
                    hd: {
                      TAG: /* Acheck */ 1,
                      _0: inp0
                    },
                    tl: {
                      hd: {
                        TAG: /* Areg */ 0,
                        _0: {
                          TAG: /* Quantified0 */ 3,
                          _0: greedy,
                          _1: $$BigInt.zero,
                          _2: noi_pred(delta),
                          _3: r1
                        }
                      },
                      tl: cont
                    }
                  }
                }, inp0, reset(gidl, gm0), dir0, fuel0);
                const o0$1 = compute_tree(params, rer, cont, inp0, gm0, dir0, fuel0);
                if (o$1 !== undefined && o0$1 !== undefined) {
                  return greedy_choice(params, greedy, {
                    TAG: /* GroupAction */ 5,
                    _0: {
                      TAG: /* Reset */ 2,
                      _0: gidl
                    },
                    _1: o$1
                  }, o0$1);
                } else {
                  return;
                }
              }
              const n = delta._0;
              if (Curry._1($$BigInt.equal(n), $$BigInt.zero)) {
                return compute_tree(params, rer, cont, inp0, gm0, dir0, fuel0);
              } else {
                Warblre_js__BigInt.Nat.pred(n);
                const gidl$1 = def_groups(params, r1);
                const o$2 = compute_tree(params, rer, {
                  hd: {
                    TAG: /* Areg */ 0,
                    _0: r1
                  },
                  tl: {
                    hd: {
                      TAG: /* Acheck */ 1,
                      _0: inp0
                    },
                    tl: {
                      hd: {
                        TAG: /* Areg */ 0,
                        _0: {
                          TAG: /* Quantified0 */ 3,
                          _0: greedy,
                          _1: $$BigInt.zero,
                          _2: noi_pred(delta),
                          _3: r1
                        }
                      },
                      tl: cont
                    }
                  }
                }, inp0, reset(gidl$1, gm0), dir0, fuel0);
                const o0$2 = compute_tree(params, rer, cont, inp0, gm0, dir0, fuel0);
                if (o$2 !== undefined && o0$2 !== undefined) {
                  return greedy_choice(params, greedy, {
                    TAG: /* GroupAction */ 5,
                    _0: {
                      TAG: /* Reset */ 2,
                      _0: gidl$1
                    },
                    _1: o$2
                  }, o0$2);
                } else {
                  return;
                }
              }
            } else {
              let min = Warblre_js__BigInt.Nat.pred(min0);
              const gidl$2 = def_groups(params, r1);
              const titer = compute_tree(params, rer, {
                hd: {
                  TAG: /* Areg */ 0,
                  _0: r1
                },
                tl: {
                  hd: {
                    TAG: /* Areg */ 0,
                    _0: {
                      TAG: /* Quantified0 */ 3,
                      _0: greedy,
                      _1: min,
                      _2: delta,
                      _3: r1
                    }
                  },
                  tl: cont
                }
              }, inp0, reset(gidl$2, gm0), dir0, fuel0);
              if (titer !== undefined) {
                return {
                  TAG: /* GroupAction */ 5,
                  _0: {
                    TAG: /* Reset */ 2,
                    _0: gidl$2
                  },
                  _1: titer
                };
              } else {
                return;
              }
            }
          case /* Lookaround */ 4 :
            const lk = r._0;
            const treelk = compute_tree(params, rer, {
              hd: {
                TAG: /* Areg */ 0,
                _0: r._1
              },
              tl: /* [] */ 0
            }, inp0, gm0, lk_dir(lk), fuel0);
            if (treelk === undefined) {
              return;
            }
            const gmlk = lk_result(params, lk, erase(params, treelk), gm0, inp0);
            if (gmlk === undefined) {
              return {
                TAG: /* LKFail */ 7,
                _0: lk,
                _1: treelk
              };
            }
            const treecont$1 = compute_tree(params, rer, cont, inp0, gmlk, dir0, fuel0);
            if (treecont$1 !== undefined) {
              return {
                TAG: /* LK */ 6,
                _0: lk,
                _1: treelk,
                _2: treecont$1
              };
            } else {
              return;
            }
          case /* Group0 */ 5 :
            const gid = r._0;
            const treecont$2 = compute_tree(params, rer, {
              hd: {
                TAG: /* Areg */ 0,
                _0: r._1
              },
              tl: {
                hd: {
                  TAG: /* Aclose */ 2,
                  _0: gid
                },
                tl: cont
              }
            }, inp0, coq_open(idx(params, inp0), gid)(gm0), dir0, fuel0);
            if (treecont$2 !== undefined) {
              return {
                TAG: /* GroupAction */ 5,
                _0: {
                  TAG: /* Open */ 0,
                  _0: gid
                },
                _1: treecont$2
              };
            } else {
              return;
            }
          case /* Anchor */ 6 :
            const a = r._0;
            if (!anchor_satisfied(params, rer, a, inp0)) {
              return /* Mismatch */ 0;
            }
            const treecont$3 = compute_tree(params, rer, cont, inp0, gm0, dir0, fuel0);
            if (treecont$3 !== undefined) {
              return {
                TAG: /* AnchorPass */ 4,
                _0: a,
                _1: treecont$3
              };
            } else {
              return;
            }
          case /* Backreference */ 7 :
            const p$1 = read_backref(params, rer, gm0, r._0, inp0, dir0);
            if (p$1 === undefined) {
              return /* Mismatch */ 0;
            }
            const tcont = compute_tree(params, rer, cont, p$1[1], gm0, dir0, fuel0);
            if (tcont !== undefined) {
              return {
                TAG: /* ReadBackRef */ 2,
                _0: p$1[0],
                _1: tcont
              };
            } else {
              return;
            }
        }
      case /* Acheck */ 1 :
        if (!is_strict_suffix(params, inp0, a0._0, dir0)) {
          return /* Mismatch */ 0;
        }
        const treecont$4 = compute_tree(params, rer, cont, inp0, gm0, dir0, fuel0);
        if (treecont$4 !== undefined) {
          return {
            TAG: /* Progress */ 3,
            _0: treecont$4
          };
        } else {
          return;
        }
      case /* Aclose */ 2 :
        const gid$1 = a0._0;
        const treecont$5 = compute_tree(params, rer, cont, inp0, close(idx(params, inp0), gid$1, gm0), dir0, fuel0);
        if (treecont$5 !== undefined) {
          return {
            TAG: /* GroupAction */ 5,
            _0: {
              TAG: /* Close */ 1,
              _0: gid$1
            },
            _1: treecont$5
          };
        } else {
          return;
        }
    }
  };
  return option_map((function (x) {
    return {
      TAG: /* Annot */ 8,
      _0: {
        acts: act,
        inp: inp0,
        gm: gm0,
        dir: dir0
      },
      _1: x
    };
  }), Curry._1($$BigInt.equal(fuel), $$BigInt.zero) ? undefined : fS(Warblre_js__BigInt.Nat.pred(fuel)));
}

const AnnotatedTrees = {
  erase: erase,
  greedy_choice: greedy_choice,
  compute_tree: compute_tree
};

function $$global(r) {
  return r.global;
}

function ignoreCase(r) {
  return r.ignoreCase;
}

function multiline$1(r) {
  return r.multiline;
}

function dotAll$1(r) {
  return r.dotAll;
}

function unicode(r) {
  return r.unicode;
}

function unicodeSets(r) {
  return r.unicodeSets;
}

function sticky(r) {
  return r.sticky;
}

function unsupported_flags(f) {
  if (f.global || f.unicode) {
    return true;
  } else {
    return f.unicodeSets;
  }
}

function linden_regex_of_warblre_regex(params, wr) {
  return warblre_to_linden$p(params, wr, $$BigInt.zero, buildnm(params, wr));
}

function maybe_add_lazy_prefix(params, f, r) {
  if (f.sticky) {
    return r;
  } else {
    return {
      TAG: /* Sequence */ 2,
      _0: lazy_star(params, {
        TAG: /* Character */ 0,
        _0: /* CdAll */ 2
      }),
      _1: {
        TAG: /* Group0 */ 5,
        _0: $$BigInt.zero,
        _1: r
      }
    };
  }
}

function tree_of_linden_regex(params, r, f, input0, startIdx0, fuel) {
  if (unsupported_flags(f)) {
    return /* TEBadFlags */ 1;
  }
  const inp0 = advance_input_n(params, {
    TAG: /* Input */ 0,
    _0: input0,
    _1: /* [] */ 0
  }, startIdx0, /* Forward */ 0);
  const rer_ignoreCase = f.ignoreCase;
  const rer_multiline = f.multiline;
  const rer_dotAll = f.dotAll;
  const rer_capturingGroupsCount = max_group(params, r);
  const rer = {
    ignoreCase: rer_ignoreCase,
    multiline: rer_multiline,
    dotAll: rer_dotAll,
    unicode: undefined,
    capturingGroupsCount: rer_capturingGroupsCount
  };
  const t0 = compute_tree(params, rer, {
    hd: {
      TAG: /* Areg */ 0,
      _0: r
    },
    tl: /* [] */ 0
  }, inp0, /* [] */ 0, /* Forward */ 0, fuel);
  if (t0 !== undefined) {
    return {
      TAG: /* TETree */ 0,
      _0: t0
    };
  } else {
    return /* TEOutOfFuel */ 0;
  }
}

const Extraction = {
  $$global: $$global,
  ignoreCase: ignoreCase,
  multiline: multiline$1,
  dotAll: dotAll$1,
  unicode: unicode,
  unicodeSets: unicodeSets,
  sticky: sticky,
  unsupported_flags: unsupported_flags,
  linden_regex_of_warblre_regex: linden_regex_of_warblre_regex,
  maybe_add_lazy_prefix: maybe_add_lazy_prefix,
  tree_of_linden_regex: tree_of_linden_regex
};

const mul = $$BigInt.mult;

const match_assertion_error = /* AssertionFailed */ 1;

const string_EqDec = string_eq_dec;

const characterValue_Hex4Digits = to_integer_4;

const input_EqDec = input_eq_dec;

const GroupMap_MapS = {
  GroupId$p: GroupId$p,
  M: M,
  Raw: Raw,
  $$this: $$this,
  empty: /* [] */ 0,
  add: add,
  find: find,
  remove: remove
};

const GroupMap = {
  MapS: GroupMap_MapS,
  empty: /* [] */ 0,
  find: find,
  coq_open: coq_open,
  close: close,
  reset: reset,
  update: update
};

export {
  xorb,
  negb,
  option_map,
  fst,
  snd,
  length,
  app,
  compareSpec2Type,
  compSpec2Type,
  mul,
  sub,
  MakeOrderTac,
  Nat,
  map,
  firstn,
  skipn,
  in_dec,
  rev,
  fold_left,
  fold_right,
  Pos,
  EqDec,
  Result,
  List,
  positive_to_nat,
  NonNegInt,
  NoI,
  RegExpRecord,
  Character,
  CharSet,
  $$String,
  Property,
  Parameters,
  Characters,
  lindenParameters_of_warblre,
  findA,
  HexDigit,
  AsciiLetter,
  Unicode,
  MatchError,
  match_assertion_error,
  Patterns,
  string_eq_dec,
  string_EqDec,
  substring0,
  advanceStringIndex0,
  getStringIndex0,
  to_char_list0,
  string_String,
  lWParameters,
  Coercions,
  characterValue_Hex4Digits,
  Semantics,
  input_eq_dec,
  input_EqDec,
  idx,
  input_str,
  substr,
  init_input,
  wordCharacters0,
  word_char,
  dot_matches,
  char_match$p,
  char_match,
  read_char,
  advance_input,
  advance_input$p,
  advance_input_n,
  GroupId,
  GroupMap,
  lk_dir,
  positivity,
  def_groups,
  max_group,
  lazy_star,
  dot_star,
  lazy_prefix,
  seqop,
  Coq__1,
  tree_res,
  strict_suffix_forward,
  strict_suffix_backward,
  is_strict_suffix,
  read_backref,
  lk_result,
  is_boundary,
  is_input_boundary,
  anchor_satisfied,
  seq_list,
  noi_pred,
  patname_eq_dec,
  patname_eqb,
  nameidx,
  buildnm$p,
  buildnm,
  num_groups,
  unicodeCodePoint,
  characterClassEsc_to_linden,
  controlEsc_singleCharacter_numValue,
  asciiEsc_singleCharacter_numValue,
  characterEscape_singleCharacter_numValue,
  characterEscape_to_linden,
  atomesc_to_linden,
  classEscape_to_linden,
  classEscape_singleCharacter_numValue,
  classAtom_to_linden,
  classAtom_singleCharacter_numValue,
  classRanges_to_linden,
  charclass_to_linden,
  wquantpref_to_linden,
  assert_idx_eq,
  warblre_to_linden,
  warblre_to_linden$p,
  AnnotatedTrees,
  Extraction,
}
/* BigInt Not a pure module */
